import React, { useEffect } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GROUP_BY = [
  {
    label: 'printout.groupByDate',
    value: 0,
  },
  {
    label: 'printout.groupByDriver',
    value: 1,
  },
]

const TimesheetHours = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData((prev: any) => ({
      groupByDate: true,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])

  const groupByOptions = Object.values(GROUP_BY).map((ct) => ({
    value: ct.value.toString(),
    label: t(ct.label),
  }))

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <FieldsetSelect
            label={t('printout.group-by')}
            placeholder={t('common.select')}
            value={data?.groupByDriver === true ? '1' : '0'}
            name="groupByDriver"
            onChange={(e) => {
              setData({
                ...data,
                groupByDriver: e.target.value === '1',
              })
            }}
            searchEnabled={false}
            options={groupByOptions}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default TimesheetHours
